<template>  
  <b-button 
    size="sm" 
    variant="secondary" 
    v-b-tooltip.hover 
    :title="showToolTip ? toolTip : ''" 
    @click="$emit('click', state)"
  >
    <i :class="state ? 'fa fa-check-circle' : 'fa fa-check-circle-o'"></i>
  </b-button>
</template>

<script>

export default ({
  name: "button-validate",

  props: {
    value: {
      type: Boolean,
      default: false
    },

    textCheck: {
      type: String,
      default: 'Валидировать'
    },

    textUncheck: {
      type: String,
      default: 'Отменить'
    }
  },

  data: () => {
    return {
      
    }
  },

  computed: {
    state: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    },

    toolTip() {
      return this.state ? this.textUncheck : this.textCheck
    }
  },

  methods: {
    
  }
})
</script>
